module.exports = __webpack_public_path__ + "img/yiqiangguang@3x.d8cc2d8b.png";